import { render, staticRenderFns } from "./WithdrawWait.vue?vue&type=template&id=4f36c2a7"
import script from "./WithdrawWait.vue?vue&type=script&lang=js"
export * from "./WithdrawWait.vue?vue&type=script&lang=js"
import style0 from "./WithdrawWait.vue?vue&type=style&index=0&id=4f36c2a7&prod&lang=scss&scooped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports